import React from 'react'
import ReactDOMServer from 'react-dom/server'

const RoleCancelledTemplate = ({ data }) => {
  const {
    companyName = '',
    jobTitle = '',
    signatureName = 'John Doe',
    signatureRole = 'Placement Coordinator',
    signatureInstitute = 'ABC Engineering College',
    signatureContact = '+91 9876543210'
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Dear students,</p>
     
      <p style={{paddingTop:'8px'}}>
        We regret to inform you that the {jobTitle} position at {companyName}, which was previously shared, has been cancelled.
      </p>
   
      <p style={{paddingTop:'10px',paddingBottom:'2px',margin:'0px'}}>Best Regards,</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureName}</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureRole}</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureInstitute}</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureContact}</p>
    </div>
  )
}

export default RoleCancelledTemplate
